/**
 * Registration Request API types and functions.
 * Will be replaced by auto-generated Api.ts once `bun run generate-types` is run.
 */
import {
  apiGet,
  apiPost,
  type ErrorResponse,
  type FetchArgsOptions,
  type FetchResponse,
  getApiUrl,
} from "Infrastructure/Api/Api";

export enum RegistrationRequestType {
  Partner = "Partner",
  Actor = "Actor",
}

export enum RegistrationRequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Resolved = "Resolved",
}

export enum RegistrationRequestListOrderBy {
  DateCreated = "DateCreated",
  Name = "Name",
  Type = "Type",
  Status = "Status",
}

export enum ResolveRegistrationRequestErrorStatus {
  NotFound = "NotFound",
  AlreadyResolved = "AlreadyResolved",
}

export type RegistrationRequestListItemDto = {
  registrationRequestID: string;
  type: RegistrationRequestType;
  status: RegistrationRequestStatus;
  firstName: string;
  lastName: string;
  company: string | null;
  email: string;
  phone: string;
  dateCreated: string;
};

export type RegistrationRequestDetailDto = RegistrationRequestListItemDto;

export type EntityListOfRegistrationRequestListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: RegistrationRequestListItemDto[];
};

export type ResolveRegistrationRequestCommandResult = Record<string, never>;

export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}

// --- API Functions ---

const basePath = () => `/api/v1/registration-requests`;

// GET list
export type GetRegistrationRequestsFetchResponse =
  | FetchResponse<EntityListOfRegistrationRequestListItemDto, 200>
  | ErrorResponse;

export const getRegistrationRequests = (
  offset?: number,
  limit?: number,
  status?: RegistrationRequestStatus | null,
  type?: RegistrationRequestType | null,
  searchQuery?: string | null,
  orderBy?: RegistrationRequestListOrderBy,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetRegistrationRequestsFetchResponse> => {
  return apiGet(`${getApiUrl()}${basePath()}`, options, {
    offset,
    limit,
    status,
    type,
    searchQuery,
    orderBy,
    sortOrder,
  }) as Promise<GetRegistrationRequestsFetchResponse>;
};

// GET detail
export type GetRegistrationRequestDetailFetchResponse =
  | FetchResponse<RegistrationRequestDetailDto, 200>
  | ErrorResponse;

export const getRegistrationRequestDetail = (
  registrationRequestID: string,
  options?: FetchArgsOptions,
): Promise<GetRegistrationRequestDetailFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${basePath()}/${registrationRequestID}`,
    options,
  ) as Promise<GetRegistrationRequestDetailFetchResponse>;
};

// POST resolve
export type ResolveRegistrationRequestFetchResponse =
  | FetchResponse<ResolveRegistrationRequestCommandResult, 200>
  | ErrorResponse;

export const postRegistrationRequestResolve = (
  registrationRequestID: string,
  options?: FetchArgsOptions,
): Promise<ResolveRegistrationRequestFetchResponse> => {
  return apiPost(
    `${getApiUrl()}${basePath()}/${registrationRequestID}/resolve`,
    undefined,
    options,
  ) as Promise<ResolveRegistrationRequestFetchResponse>;
};
